import { render, staticRenderFns } from "./CText.vue?vue&type=template&id=fe299a72&"
import script from "./CText.vue?vue&type=script&lang=js&"
export * from "./CText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports